<script setup lang="ts">
import type { OrganizationJs } from "@/generated/models";
import FormattedDate from "ls/components/FormattedDate.vue";
import { useOrganizationCloudPlusStatus } from "../../organizations/useOrganizationCloudPlusStatus";

const props = defineProps<{
  organization: OrganizationJs;
}>();

const { whitelistExpiration } = useOrganizationCloudPlusStatus(() => props.organization);
</script>

<template>
  <div v-if="whitelistExpiration">
    Thank you for being a part of the whiteboards and documents beta. You can continue using them for free until <FormattedDate :value="whitelistExpiration" short />.
    After that, anyone using whiteboards and documents will need a Cloud Author seat for Cloud for Business.
  </div>
</template>
